/**
 * Guard checking if argument has a value
 * Aka is not: undefined, null or NaN
 * @template T - guard type
 * @param {T | undefined | null} value - to check for value
 * @returns {boolean} true if argument as value
 */
const hasValue = <T>(value: T | undefined | null): value is T => {
  return <T>value !== undefined && <T>value !== null && (typeof value === "number" ? !Number.isNaN(value) : true);
};

/**
 * Does all arguments contain a value
 * Containing a value means NOT having undefined or null
 * @example
 * // returns true
 * action.hasAllValues("hello", 42);
 * @example
 * // returns false
 * action.hasAllValues("hello", undefined);
 * @example
 * // returns true - the array exists, content is NOT checked
 * action.hasAllValues([undefined, undefined]);
 * @param {unknown[]} args - to check for values
 * @returns {boolean} true if all values is not undefined or null
 */
const allHasValues = (...args: unknown[]): boolean => {
  return args.every(hasValue);
};

export {allHasValues, hasValue};
